"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEASURE_UNIT_CODES = exports.UNDEFINED_MEASURE_UNIT_CODE = void 0;
exports.UNDEFINED_MEASURE_UNIT_CODE = 255;
exports.MEASURE_UNIT_CODES = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    128,
    129,
    130,
    132,
    133,
    134,
    135,
    139,
    140,
    141,
    142,
    143,
    146,
    148,
    149,
    150,
    151,
    152,
    153,
    154,
    155,
    160,
    165,
    170,
    171,
    172,
    173,
    174,
    180,
    181,
    182,
    183,
    184,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    210,
    211,
    212,
    213,
    214,
    215,
    exports.UNDEFINED_MEASURE_UNIT_CODE,
];
//# sourceMappingURL=measure-units.js.map